import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './landing.css';
import './blog.css';

export default function BlogLayout({ children }) {
  const [navScrolled, setNavScrolled] = useState(false);

  const onScroll = useCallback(() => {
    setNavScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  return (
    <div className="landing blog-page">
      <nav
        className={`landing-nav${navScrolled ? ' landing-nav--scrolled' : ''}`}
        aria-label="Primary"
      >
        <Link to="/" className="landing-nav__brand">
          <span className="landing-nav__wordmark">Sovrynn</span>
          <span className="landing-nav__trails" aria-hidden>
            <span className="landing-nav__trail landing-nav__trail--1" />
            <span className="landing-nav__trail landing-nav__trail--2" />
          </span>
        </Link>
        <div className="landing-nav__actions">
          <Link to="/login" className="landing-nav__signin">
            Sign In
          </Link>
          <Link to="/register" className="landing-nav__cta">
            Get Started Free
          </Link>
        </div>
      </nav>

      {children}

      <footer className="landing-footer">
        <div className="landing-footer__grid">
          <div>
            <div className="landing-footer__wordmark">Sovrynn</div>
            <div className="landing-footer__wordmark-trails" aria-hidden>
              <div className="lp-trail" style={{ width: 40, height: 2 }} />
              <div className="lp-trail lp-trail--dim" style={{ width: 26, height: 2, marginTop: 4 }} />
            </div>
            <p className="landing-footer__tag">
              Compliance Intelligence for the independent commercial operator
            </p>
            <p className="landing-footer__co">A Tearratopia Holdings Company</p>
          </div>
          <div className="landing-footer__links">
            <Link to="/blog">Blog</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/login">Sign In</Link>
          </div>
        </div>
        <p className="landing-footer__copy">© 2026 Sovrynn LLC. All rights reserved.</p>
      </footer>
    </div>
  );
}
